import { Receipt, Droplets, Euro, Gauge } from 'lucide-react';
import { money } from './fuelUtils';

const fmt = (n, d = 0) => (n == null ? '—' : Number(n).toLocaleString('nl-BE', { minimumFractionDigits: d, maximumFractionDigits: d }));

export function SubsSummary({ s }) {
  const items = [
    [Receipt, 'Bildirim / fiş', `${fmt(s?.submissions)} / ${fmt(s?.receipts)}`, 'text-slate-900 dark:text-white', 'bg-slate-100 text-slate-600'],
    [Droplets, 'Toplam litre', `${fmt(s?.liters, 2)} L`, 'text-sky-700', 'bg-sky-100 text-sky-600'],
    [Euro, 'Toplam tutar', money(s?.total), 'text-orange-600', 'bg-orange-100 text-orange-600'],
    [Gauge, 'Ort. litre fiyatı', s?.avg_price ? `€ ${fmt(s.avg_price, 3)}` : '—', 'text-emerald-700', 'bg-emerald-100 text-emerald-600'],
  ];
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-testid="fuel-summary">
      {items.map(([Icon, label, val, vcls, icls], i) => (
        <div key={label} className="rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-4 flex items-center gap-3" data-testid={`fuel-summary-${i}`}>
          <span className={`h-10 w-10 rounded-xl flex items-center justify-center shrink-0 ${icls}`}><Icon className="h-5 w-5" /></span>
          <div className="min-w-0"><div className="text-[11px] uppercase tracking-wider text-slate-400 truncate">{label}</div><div className={`text-lg sm:text-xl font-black tabular-nums truncate ${vcls}`}>{val}</div></div>
        </div>
      ))}
    </div>
  );
}
